import { CommonGet, CommonPost, CommonGetIDServer } from "../../../utils/CommonFetch";

export default {
    getGroups,
    getOperationEntitiesByGroupForDropDown,
    getDivisions,
    getUsers,
    getFieldUserMappingList,
    FieldUserMappingSave,
    FieldUserMappingDelete,
    CheckFieldUserMappingExists
};

async function getDivisions(estateID) {
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateId=' + estateID);
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
    }
    return array;
}

async function getOperationEntitiesByGroupForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllEstateFilteredOperationEntityByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getGroups() {
    let response = await CommonGet('/api/Group/GetAllGroups', null);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getUsers(collectionPointID) {
    let response = await CommonGet('/api/FieldUserMapping/GetAllUsers', 'collectionPointID=' + collectionPointID);
    let userArray = []
    for (let item of Object.entries(response.data)) {
        userArray[item[1]["userID"]] = item[1]["userName"];
    }
    return userArray;
}

async function getFieldUserMappingList(userID) {
    var response = await CommonGet('/api/FieldUserMapping/GetFieldUserMappingList', 'userID=' + userID);
    return response.data;
}

async function FieldUserMappingSave(saveData) {
    const response = await CommonPost('/api/FieldUserMapping/SaveFieldUserMapping', null, saveData);
    return response;
}

async function FieldUserMappingDelete(userAssignCollectionPointID, modifiedBy) {
    const body = {
        userAssignCollectionPointID: userAssignCollectionPointID,
        modifiedBy: modifiedBy
    };
    const response = await CommonPost('/api/FieldUserMapping/UpdateFieldUserMapping', null, body);
    return response;
}

async function CheckFieldUserMappingExists(userID, allowDivisionID) {
    const body = {
        userID: parseInt(userID),
        allowDivisionID: parseInt(allowDivisionID)  
    };
    const response = await CommonPost('/api/FieldUserMapping/CheckFieldUserMappingExists', null, body);
    return response;
}